<template>
  <div class="order" style="padding-bottom: 60px">
    <header>
      <div class="headerDiv" v-on:click="backHistory"  @click="">
        <img src="@/assets/img/back.png" alt="">
        <p style="color: #FFFFFF">订单信息</p>
      </div>
    </header>
    <div style="">
      <div style="background:#ff2500">
      <div class="orderMessage" >
        <div class="orderIcon">
          <van-icon size="20" color="#FFFFFF" name="location" />
        </div>
        <div class="orderP">
          <p><span>{{address.name}}</span> {{address.tel}}</p>
          <p @click="toAddress">{{address.province}}{{address.city}}{{address.county}}{{address.address}}</p>
        </div>
      </div>
      </div>
      <div v-for="(pros,index) in list">
      <div class="orderDetail" v-for="(item,key) in pros.item" >
        <p class="orderShopIcon">
          <img style="width: 20px" :src="item.merchant_logo" v-if="item.merchant_logo" alt="">
          <span v-else=""><van-icon  name="shop-o" size="20" /></span>
          <span style="margin-left: 10px">{{item.merchant_title}}</span></p>
        <div class="orderDetailDiv" v-for="(shop,number) in item.goods">
          <!--<div class="orderDetailTitle">-->
            <div  class="orderDetailTitleImg">
              <img :src="shop.image" alt="">
            </div>
            <div class="orderDetailMessage">
              <!--<div>-->
                <p style="font-weight: 600;margin-left: -5px">【{{shop.title}}】</p>
                <!--<p v-for="(a,b) in shop.spec_type">{{a.name}}：{{a.value}}</p>-->
                <p style="color: grey">数量:{{shop.buy_number}}<soan v-for="(a,b) in shop.spec_type">&nbsp;&nbsp;<span>{{a.name}}&nbsp;&nbsp;{{a.value}}</span></soan></p>
                <p style="font-weight: bold;color: #ff2500">￥{{shop.price}}</p>
            </div>
        </div>
      </div>
      </div>
      <div class="orderNum">
        <p><span>订单编号：</span><span style="font-weight: 600">{{data.order_no}}</span></p>
        <!--<div class="productType" @click="showPopup">-->
          <!--<p><span class="productx">选择</span><span class="productg">选择规格</span></p>-->
          <!--<p class="productPrice"><span class="productImg"></span></p>-->
          <p v-if="orderTid" @click="twoCode" style="display: flex;justify-content: space-between;"><span>分享二维码</span><span class="productImg"></span></p>
        <!--</div>-->
        <p>支付方式：<span style="font-weight: 600">在线支付</span></p>
        <p>下单时间：<span style="font-weight: 600">{{time}}</span></p>
        <p class="orderNumprice"><span>商品总额</span><span>￥{{allPrice}}</span></p>
        <p class="orderNumprice"><span>商品优惠</span><span>￥{{data.preferential_price}}</span></p>
        <p class="orderTotal_price"><span>应付款：￥{{allPrice-data.preferential_price}}</span></p>
      </div>
    </div>
    <van-popup v-model="show3" @click="" closeable position="bottom" :style="{ height: '100%',    background: 'rgba(0,0,0,0.1)' }" ><!--拼团弹框-->
      <!--<div>-->
      <div style="width: 80%;margin: auto">
        <img style="width: 100%" :src=imgUrl alt="">
      </div>
      <img src="" alt="">
      <div class="collageBottom">
        <!--<div>-->
          <!--<p style="background: #07c160" @click.stop="alertShow4">-->
            <!--<span style="width: 35px;height: 35px"><van-icon name="wechat" color="#fff" size="35px"/></span>-->
          <!--</p>-->
          <!--<span style="padding-top: 10px">分享给好友</span>-->
        <!--</div>-->
        <div>
          <p  @click="saveAlert">
            <!--<span style="width: 35px;height: 35px"><van-icon name="down" color="#07c160" size="30px"/></span>-->
            <span style="width: 40px;height: 40px"><img width="100%" src="@/assets/img/download.jpg" alt=""></span>
          </p>
          <span style="padding-top: 10px">保存图片</span>
        </div>
        <!--<p style="background: #7c6cd7">-->
        <!--<span style="width: 40px;height: 40px"><van-icon name="down" color="#07c160" size="40px"/></span>-->
        <!--<span>分享给好友</span>-->
        <!--</p>-->
      </div>

      <!--<div>-->
      <!--<img src="@/assets/img/share.png" alt="">-->
      <!--</div>-->
      <!--</div>-->

    </van-popup>
    <van-popup v-model="show4" @click="hideShow4" closeable position="bottom" :style="{ height: '100%',    background: 'rgba(0,0,0,0.1)' }" >拼团弹框
      <div>
        <img style="width:100%;" src="@/assets/img/share.png" alt="">
      </div>
    </van-popup>
    <van-tabbar v-model="active">
      <!--<van-tabbar-item >-->
       <div class="footerDiv" v-if="this.data.pay_status==1">
         <p @click="deleteOrder">删除订单</p>
         <p class="buyAgain" @click="saveCart">再次购买</p>
       </div>
      <div class="footerDiv" v-if="this.data.pay_status==0">
        <p @click="deleteOrder">删除订单</p>
        <p class="buyAgain" @click="toOrderPay">去支付</p>
      </div>
      <!--</van-tabbar-item>-->
    </van-tabbar>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { Swipe, SwipeItem } from 'vant';

  Vue.use(Swipe);
  Vue.use(SwipeItem);
  //  import Vue from 'vue';
  import { Lazyload } from 'vant'
  Vue.use(Lazyload);
  export default {
    name: 'message',
    data () {
      return {
        msg: '',
        data:[],
        address:{},
        active: 0,
        icon: {
          active: 'https://img01.yzcdn.cn/vant/user-active.png',
          inactive: 'https://img01.yzcdn.cn/vant/user-inactive.png',
        },
        allPrice:0,
        time:"",/*下单时间取的商品中的第一个时间*/
        count:0,
        show3:false,
        show4:false,
        imgUrl:"",
        goodsid:"",
        orderTid:""//订单团ID
      }
    },
    created(){

    },
    methods: {
      backHistory(){
        this.$router.go(-1)
      },
      twoCode(){
        this.show3=true
      },
      alertShow3(){
        this.show3=false
      },
      alertShow4(){
        this.show4=true
      },
      saveAlert(){/*保存图片提示*/
        this.$toast("长按图片进行保存哦~")
      },
      hideShow4(){

        this.show4=false
      },
      toAddress(){
        this.$router.push("/harvestAddress")
      },
      selectOrderDetail(){
//        this.imgUrl=localStorage.getItem("orderImg")
        this.orderTid=this.$route.query.orderTid
        console.log(this.orderTid)
        this.$api.selectOrderDetail({
          id:this.$route.query.id
        })
          .then(res=>{
            this.list=res.data
            this.data=res.data[0]
            console.log(this.data)
//            优惠券价格为null时等于0
            this.data.preferential_price=this.data.preferential_price==null?0:this.data.preferential_price
            this.address=res.data[0].address
            this.time=res.data[0].item[0].goods[0].add_time
            this.goodsid=res.data[0].item[0].goods[0].goods_id
            this._totalPeice()
            if(this.orderTid){
              this.openqrcode()
            }

          })

      },
      toOrderPay(){
        let number=0
        this.data.item.forEach(item => {
          item.goods.forEach(pros=>{
            number+=Number(pros.buy_number)
          })
        })
        localStorage.setItem("order",this.data.order_no )
        this.$router.push({
          path:"/orderPay",
          query:{
            id:this.allPrice,
            order:this.data.order_no,
            count:number
          }
        })
      },
      saveCart(){//加入购物车
        this.$api.insertCarts({
          id:this.data.id,
          "data[user_id]":localStorage.getItem("userid"),
          "data[goods_id]":this.data.goods_id,
          "data[goods_spec_id]":this.data.goods_spec_id,
          "data[title]":this.data.title,
          "data[img]":this.data.image,
          "data[price]":this.data.price,
          "data[original_price]":this.data.original_price,
          "data[stock]":this.data.buy_number,
        })
          .then(res=>{
            this.$router.push("/newShop")
            this.$toast("成功添加购物车")
          })
        this.show = false;
      },
      _totalPeice () {
        // 每次调用此方法，将初始值为0，遍历价格并累加
        this.allPrice = 0
        this.arrList=[]
        let price=0
        this.data.item.forEach(item => {
          item.goods.forEach(pros=>{
            price+=Number(pros.total_price)
          })
        })
        this.allPrice=price
      },
      deleteOrder(){//删除
        this.$dialog.alert({
          title: '是否删除该订单',
          message: '',
          showCancelButton:true
        }).then(() => {
          this.$api.deleteOrder({
            id:this.data.id,
          })
            .then(res=>{
              this.$router.push("/allOrder")
              this.$toast("成功删除订单")
            })
        });
      },
      openqrcode(){
        console.log(new Date())
        var timestamp = Date.parse(new Date());
        this.$api.openqrcode({
          "goods_id":this.goodsid,
          "is_group":1,
          "time":timestamp,
          "user_id":localStorage.getItem("userid"),
          "tid":this.$route.query.orderTid
        })
          .then(res=>{
            this.imgUrl=res.url
          })
      }
    },
    mounted(){
      this.selectOrderDetail()

    }
  }
</script>

<style  scoped="">
  *{
    /*overflow-x:hidden;*/
    padding: 0;
    margin: 0;
  }
  header{
    width: 100%;
    height: 60px;
    background:#ff2500 ;
    position: fixed;
    z-index: 200;
    top: 0;
  }
  header img{
    width: 20px;
    height: 20px;
  }
  .headerDiv{
    display: flex;
    align-items: center;
    line-height: 60px;
  }
  .headerDiv p{
    margin: auto;
    font-size: 18px;
  }
  .order{
    width: 100%;
    height: 100%;
    /*background: #E4E4E4;*/
    padding-top: 60px;
  }
  .orderMessage{
    /*margin-top: 60px;*/
    /*margin-top: 60px;*/
    display: flex;
    align-items: center;
    padding: 10px;
    background: #ffffff;
    /*width: 85%;*/
    margin: 0 auto;
    border-radius: 12px 12px 0 0;
    font-size: 14px;
  }

  .orderIcon{
    background: #F05732;
    width: 25px;
    height: 25px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .orderP{
    padding: 5px 0;
    margin-left: 10px;
  }
  .orderDetail{
    /*width: 90%;*/
    /*margin:20px auto;*/
    background: #ffffff;
    /*border-radius: 10px;*/
    padding: 10px;
    border-top: solid 8px #e4e4e4;
  }
  .orderShopIcon{
    display: flex;
    align-items: center;
  }
  .orderDetailTitle{
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
  .orderDetailTitleImg{
    width: 80px;
    /*height: 80px;*/
  }
  .orderDetailTitleImg img{
    width: 100%;
    /*height: 100%;*/
  }
  .orderDetailMessage{
    font-size: 14px;
    margin-left: 10px;
  }
  .orderDetailMessage p{
    margin-top: 5px;
  }
  .orderDetailQ{
    /*margin-left: 1rem;*/
    float: right;
    color: #f56723;
  }
  .orderDetailDiv{
    display: flex;
    /*justify-content: space-between;*/
    padding-top: 10px;
    align-items: center;
  }
  .orderBottom span{
    padding: 0 2px;
  }
  .orderBottom{
    margin-right: 15px;
  }
  .button{
    padding: 1px 1px;
    padding: 8px 18px;
    border-radius: 3rem;
    border: none;
    background: linear-gradient(to right,#ff6034,#ee0a24);
    color: #FFFFFF;
    font-size: 15px;
  }
  /deep/.van-button{
    right:10px;
  }
  .orderDetailBottom{
    font-size: 14px;
    margin-top: 10px;
    padding-left: 2rem;
  }
  .productType{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0;
  }
  .productx{
    color: #c9c9c9;
    margin-left: 1rem;
  }
  .productg{

  }
  .productImg{
    background-image: url(../../assets/img/gonext.png);
    background-repeat: no-repeat;
    background-position: 98% center;
    background-size: 7px 15px;
    padding-right: 1rem;
  }
  .orderTotal{
    display: flex;
    justify-content: flex-end;
    padding-right: 1rem;
  }


  /*//订单信息*/
  .orderNum{
    border-top: solid 8px #E4E4E4;
    padding: 15px;
  }
  .orderNum p{
    /*margin-top: 1px;*/
    /*color: #898888;*/
    margin-top: 20px;
    font-size: 15px;
  }
  .orderNumprice{
   display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .orderTotal_price{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    color: #ff2500;
    font-weight: 600;
  }
  /*脚部*/
  .buyAgain{
    padding: 5px 12px;
    border: solid 1px #ff2500;
    border-radius: 1rem;
    font-size: 12px;
    background: #ff2500;
    color: #ffffff;
  }

  footer{
    width: 100%;
    height: 40px;
    background:red ;
    position: fixed;
    z-index: 200;
    bottom: 0;

  }

  .footerDiv{
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    padding: 0 15px;
    font-size: 13px;
    font-weight: 600;
  }
  /*评团弹框样式*/
  .collageBottom {
    width: 100%;
    background: #fff;
    height: 100px;
    bottom: 0;
    position: absolute;
    border-radius: 10px 10px 0 0;
    display: flex;
    font-size: 13px;
    align-items: center;
    justify-content: space-around;
  }

  .collageBottom p {
    /*background: #7c6cd7;*/
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    text-align: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 100%;
  }

  .collageBottom div {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/components/shop/allOrderDetail.vue